<template>
  <v-row no-gutters class="align-center">
    <v-col v-for="button in buttons" cols="auto" :key="button.name">
      <slot :name="button.name + '-outter'" v-bind="button">
        <table-button v-on="$listeners" v-bind="button">
          <template #default="data">
            <slot :name="button.name" v-bind="data"> </slot>
          </template>
        </table-button>
      </slot>
    </v-col>
  </v-row>
</template>

<script>
import TableButton from '@/components/TableButton';

export default {
  name: 'TableButtons',
  components: {
    TableButton,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
